import { render } from "./CardChallengeResultItemCompleted.vue?vue&type=template&id=3722193e&scoped=true"
import script from "./CardChallengeResultItemCompleted.vue?vue&type=script&lang=js"
export * from "./CardChallengeResultItemCompleted.vue?vue&type=script&lang=js"

import "@/css/components/card-challenge-result-item-completed.css?vue&type=style&index=0&id=3722193e&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3722193e"]])

export default __exports__